import React from 'react';
import styles from './Table.module.css';

export interface TableCellProps {
  children: React.ReactNode;
  align?: 'left' | 'center' | 'right';
  className?: string;
}

const TableCell: React.FC<TableCellProps> = ({ 
  children, 
  align = 'left',
  className = '' 
}) => {
  const alignClass = align === 'center' 
    ? styles.cellCentered 
    : align === 'right' 
    ? styles.cellRight 
    : '';

  return (
    <div className={`${styles.tableCell} ${alignClass} ${className}`}>
      {children}
    </div>
  );
};

export default TableCell;

